import React from 'react'
import "./Learning.css"
import brochure from "../../app/assets/document/Camp Hornbill For School & Colleges.pdf"
import leafSvg from "../../app/assets/images/icons/nature-learning.webp"
import leadershipImg from "../../app/assets/images/icons/leadership.webp"
import ecologyImg from "../../app/assets/images/icons/ecology.webp"
import immersionImg from "../../app/assets/images/icons/immersion.webp"
import trainedImg from "../../app/assets/images/icons/trained-facility.webp"

function Learning() {
  const downloadBrochure = () => {
    const link = document.createElement("a");
    link.href = brochure;
    link.download = "Camp Hornbill For School & Colleges.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <section className="learning-hero banner_sec section-padding">
        <div className="container">
          <div className='banner-wraper'>
            <h1 className="banner-heading">
              Where Classrooms <span className="text-yellow">Open</span> into <span className="text-yellow">Forests</span>
            </h1>
            {/* <p className="banner-sub-heading">Nature learning camps in Uttarakhand.</p> */}
            {/* <p className="content text-white">
              Camp Hornbill transforms the forest into a living classroom. Through hands-on experiences, students explore ecology, sustainability, and leadership in real-world contexts. From observing biodiversity to engaging in rural practices, every activity builds curiosity, confidence, and a deeper understanding of the natural world.
            </p> */}
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="section-padding bg-color">
        <div className='container'>
          <div className=''>
            <h2 className="heading text-center mb-4">
              Nature Learning Camps in <span className="text-yellow">Uttarakhand</span>
            </h2>
            <div className='diveder-bx'></div>
            <p className="content text-center">
              Camp Hornbill transforms the forest into a living classroom. Through hands-on experiences, students explore ecology, sustainability, and leadership in real-world contexts. From observing biodiversity to engaging in rural practices, every activity builds curiosity, confidence, and a deeper understanding of the natural world.
            </p>
            <p className="content text-center">
              Our programs are designed to spark curiosity, build resilience, and foster a deeper understanding of the natural world.
              Through guided activities and real-world exposure, students become active participants rather than passive learners.
            </p>
          </div>
        </div>
      </section>

      {/* Pillars of Learning - Grid */}
      <section className="section-padding">
        <div className='container'>
          <div className="row g-4 justify-content-center">
            <div className="col-md-4 text-center">
              <div className="info-card bg-white h-100 shadow-sm border-0">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/biodiversity-learning.webp")} alt="image" className="card-img-top" />
                  <div className="info-card-body p-3 text-start">
                    <h6 className="sub-heading">Ecology & Biodiversity Learning</h6>
                    <p className="content">Curriculum-linked activities that bring ecology and geography to life through hands-on exploration.</p>
                    {/* <a className="explore-text text-decoration-none">
                      Explore
                      <img loading="lazy" decoding="async" src={arrowSvg} className='arrow-img' alt='arrow' />
                    </a> */}
                  </div>
                </div>
              {/* <div className="learning-card">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/biodiversity-learning.webp")} alt="Image" />
                <div className="content-wraper">
                  <h5 className="sub-heading text-white">Ecology and biodiversity learning</h5>
                  <p className="content text-white">Curriculum-linked activities that bring ecology and geography to life through hands-on exploration.</p>
                </div>
              </div> */}
            </div>
            <div className="col-md-4 text-center">
              <div className="info-card bg-white h-100 shadow-sm border-0">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/rural-immersion.webp")} alt="image" className="card-img-top" />
                  <div className="info-card-body p-3 text-start">
                    <h6 className="sub-heading">Sustainability & Rural Immersion</h6>
                    <p className="content">Hands-on sessions on waste management, organic farming, and community-led conservation.</p>
                    {/* <a className="explore-text text-decoration-none">
                      Explore
                      <img loading="lazy" decoding="async" src={arrowSvg} className='arrow-img' alt='arrow' />
                    </a> */}
                  </div>
                </div>
              {/* <div className="learning-card">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/rural-immersion.webp")} alt="Image" />
                <div className="content-wraper">
                  <h5 className="sub-heading text-white">Sustainability and rural immersion</h5>
                  <p className="content text-white">Hands-on sessions on waste management, organic farming, and community-led conservation.</p>
                </div>
              </div> */}
            </div>
            <div className="col-md-4 text-center">
              <div className="info-card bg-white h-100 shadow-sm border-0">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/leadership.webp")} alt="image" className="card-img-top" />
                  <div className="info-card-body p-3 text-start">
                    <h6 className="sub-heading">Leadership & Outdoor Challenges</h6>
                    <p className="content">Team-building, outdoor challenges, and survival skills that build confidence and resilience.</p>
                    {/* <a className="explore-text text-decoration-none">
                      Explore
                      <img loading="lazy" decoding="async" src={arrowSvg} className='arrow-img' alt='arrow' />
                    </a> */}
                  </div>
                </div>
              {/* <div className="learning-card">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/leadership.webp")} alt="Image" />
                <div className="content-wraper">
                  <h5 className="sub-heading text-white">Leadership and outdoor challenges</h5>
                  <p className="content text-white">Team-building, outdoor challenges, and survival skills that build confidence and resilience.</p>
                </div>
              </div> */}
            </div>
            <div className="col-md-4 text-center">
              <div className="info-card bg-white h-100 shadow-sm border-0">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/education.webp")} alt="image" className="card-img-top" />
                  <div className="info-card-body p-3 text-start">
                    <h6 className="sub-heading">Real World Experiential Education</h6>
                    <p className="content">Engage in immersive, hands-on learning experiences that connect classroom concepts with real-world environments and practical skills.</p>
                    {/* <a className="explore-text text-decoration-none">
                      Explore
                      <img loading="lazy" decoding="async" src={arrowSvg} className='arrow-img' alt='arrow' />
                    </a> */}
                  </div>
                </div>
              {/* <div className="learning-card">
                  <img loading="lazy" decoding="async" src={require("../../app/assets/images/education.webp")} alt="Image" />
                <div className="content-wraper">
                  <h5 className="sub-heading text-white">Real-world experiential education</h5>
                  <p className="content text-white">Engage in immersive, hands-on learning experiences that connect classroom concepts with real-world environments and practical skills.</p>
                </div>
              </div> */}
            </div>

          </div>
        </div>
      </section>

      {/* Safety & Expert Section */}
      <section className="section-padding">
        <div className='container'>
          <div className="row align-items-center g-5">
            <div className="col-md-6 ">
              <div className='expert-img'>
                <div className='img-wrapper'>
                  <img loading="lazy" decoding="async"
                    src={require("../../app/assets/images/safety-expert.webp")}
                    alt="Facilitation"
                    className="facilitation-img shadow-lg"
                  /> 
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className='mb-4'>
                <h2 className="heading">Safety & Expert <span>Facilitation</span></h2>
              </div>

              <div className="feature-item">
                <img loading="lazy" decoding="async" src={trainedImg} alt="Image" />
                <div>
                  <h6 className="sub-heading">Trained facilitators & local guides</h6>
                  <p className="content">Experts who bridge the gap between academic theory and indigenous forest knowledge.</p>
                </div>
              </div>

              <div className="feature-item">
                <img loading="lazy" decoding="async" src={require("../../app/assets/images/icons/eye.webp")} alt="Image" />
                <div>
                  <h6 className="sub-heading">Structured group supervision</h6>
                  <p className="content">Constant monitoring within a safe, yet authentic natural environment.</p>
                </div>
              </div>

              <div className="feature-item">
                <img loading="lazy" decoding="async" src={require("../../app/assets/images/icons/risk-aware.webp")} alt="Image" />
                <div>
                  <h6 className="sub-heading">Risk-aware activity design</h6>
                  <p className="content">Activities meticulously planned to balance challenge with student safety.</p>
                </div>
              </div>

              <div className="feature-item">
                <img loading="lazy" decoding="async" src={require("../../app/assets/images/icons/cap.webp")} alt="Image" />
                <div>
                  <h6 className="sub-heading">Suitable for school groups</h6>
                  <p className="content">Customized itineraries catering to specific educational age groups.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section bg-color">
        <div className="container">
          <h3 className="heading text-center">Ready to take learning beyond the classroom?</h3>
          <p className="content text-center">Talk to our Learning Team and bring your students to Camp Hornbill.</p>
          <div className="d-flex flex-wrap justify-content-center gap-3 btn-wraper">
            <button className="outline_btn" onClick={downloadBrochure}>Download Program Brochure</button>
          </div>
        </div>
      </section>
    </>
  )
}

export default Learning